import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faLink,
	faWindowClose,
	faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";
import 'font-awesome/css/font-awesome.min.css';
import { Toolbar, Data, Filters } from "react-data-grid-addons";

const defaultColumnProperties = {
	resizable: true,
};

export const selectors = Data.Selectors;

const UrlFormatter = ({ value }) => {
	if (value == null || value == "") {
		return <div></div>;
	}
	return (
		<a href={value}>
			<FontAwesomeIcon icon={faExternalLinkAlt} size="xs" />
		</a>
	);
};

const MoneyFormatter = ({ value }) => {
	let val = parseFloat(value).toFixed(2);
	return <div>${val}</div>;
};

const NotesFormatter = ({ value }) => {
	let information = "Do Not Stock, Order Per Job";
	let connectorInformation = "Special Connector Required";
	//at a later date when/if this grows I need to do some sort of if else if and chain together and build the div I wish to return to maintain only a single return
	//for now im coding to acomodate the two situations that can occur.
	if (value != null) {
		if (
			value.includes("DO NOT STOCK") &&
			value.includes("(SPECIAL CONNECTOR REQUIRED")
		) {
			let val = value.replace(
				"DO NOT STOCK - ORDER PER JOB (SPECIAL CONNECTOR REQUIRED",
				""
			);
			return (
				<div>
					<FontAwesomeIcon
						title={information}
						style={{ margin: 2 }}
						icon={faWindowClose}
						color="red"
						size="xs"
					/>
					<FontAwesomeIcon
						title={connectorInformation}
						style={{ margin: 2 }}
						icon={faLink}
						color="green"
						size="xs"
					/>
					{val}
				</div>
			);
		}
		if (value.includes("DO NOT STOCK")) {
			let val = value.replace("DO NOT STOCK - ORDER PER JOB", "");
			return (
				<div>
					<FontAwesomeIcon
						title={information}
						style={{ margin: 2 }}
						icon={faWindowClose}
						color="red"
						size="xs"
					/>
					{val}
				</div>
			);
		}
	}
	return <div></div>;
};

const createBranchColumns = (size) => {
	const columns = [
		{
			key: "description",
			name: "Description",
			editable: false,
		},
		{
			key: "typeOfEquipment",
			name: "Type",
			editable: false,
			sortDescendingFirst: true,
			filterable: true,
			filterRenderer: Filters.MultiSelectFilter,
		},
		{
			key: "importantNotes",
			name: "Imp. Notes",
			editable: false,
			formatter: NotesFormatter,
		},
		{
			key: "oldPartNumber",
			name: "Old Part Number",
			editable: false,
		},
		{
			key: "newPartNumber",
			name: "Part Number",
			editable: false,
		},
		{
			key: "cost",
			name: "Product Cost",
			formatter: MoneyFormatter,
		},
		{
			key: "unitOfMeasure",
			name: "Measure",
			editable: false,
		},
		{
			key: `${size}DesiredQuantity`,
			name: "Stock lvl",
			editable: false,
		},
		{
			key: "onHandQuantity",
			name: "On Hand",
			editable: true,
		},
		{
			key: "url",
			name: "Link",
			formatter: UrlFormatter,
		},
		{
			key: "quantity",
			name: "Quantity",
			editable: true,
		}
	];

	return columns.map((c) => ({ ...c, ...defaultColumnProperties }));
};

export const jobColumns = createBranchColumns("")
// .filter((column) => column.name !== "Stock lvl" && column.name !== "On Hand");

export const smallBranchColumns = createBranchColumns("small");
export const mediumBranchColumns = createBranchColumns("medium");
export const largeBranchColumns = createBranchColumns("large");
